/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {ApplicationRef, ComponentFactoryResolver, Injectable, Injector} from '@angular/core';
import {FcAgUtilsService} from '../fc-ag-services/fc-ag-utils.service';
import {FcAgLoadingMaskHolderComponent} from './fc-ag-loading-mask-holder.component';

/**
 * Loading Mask service.
 */
@Injectable({
    providedIn: 'root'
})
export class FcAgLoadingMaskService {

    private FcAgLoadingMaskHolder: FcAgLoadingMaskHolderComponent;
    
    /**
     * Constructor for service.
     *
     * @param resolver Component Factory Resolver.
     * @param applicationRef Component Reference.
     * @param injector Component Injector.
     * @param fcAgUtilsService FcAgUtilsService.
     */
    constructor(
        private resolver: ComponentFactoryResolver,
        private applicationRef: ApplicationRef,
        private injector: Injector,
        private fcAgUtilsService: FcAgUtilsService
    ) {}

    /**
     * Show loading mask.
     */
    showLoadingMask(): void {
        if (!this.FcAgLoadingMaskHolder) {
            this.FcAgLoadingMaskHolder = this.fcAgUtilsService.createHolderComponent(
                FcAgLoadingMaskHolderComponent,
                this.resolver, this.applicationRef, this.injector);
        }
        this.FcAgLoadingMaskHolder.showLoadingMask();
    }

    /**
     * Hide loading mask.
     */
    hideLoadingMask(): void {
        this.FcAgLoadingMaskHolder.hideLoadingMask();
    }
}